import { richTextFromMarkdown } from '@contentful/rich-text-from-markdown'
import { CtfRichText, type ContentfulRichTextInterface } from './ctf-rich-text'

export type CtfMarkdownAllowedInstrinsicElements = 'div' | 'fragment'

export type ContentfulMarkdownTextInterface = {
  markdown: string
  as?: CtfMarkdownAllowedInstrinsicElements
} & Pick<ContentfulRichTextInterface, 'className' | 'links' | 'styling'>

export const CtfMarkdownText = async ({
  markdown,
  links,
  className,
  styling = 'margins-only',
  as,
}: ContentfulMarkdownTextInterface) => {
  const document = await richTextFromMarkdown(markdown)
  return (
    <CtfRichText
      as={as}
      json={document}
      links={links}
      className={className}
      styling={styling}
    />
  )
}
